/**
 * Central configuration for the frontend application.
 * The API base URL is retrieved from the environment variable REACT_APP_API_URL.
 * If the environment variable is not set, it defaults to the production server.
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://server7e.scifi.ink';
const WS_BASE = process.env.REACT_APP_WS_BASE || 'ws://server7e.scifi.ink';
const FEATURE_INVITE_TOKEN = process.env.REACT_APP_FEATURE_INVITE_TOKEN || 'false'
const ALLOW_FREE_SUBSCRIPTION = process.env.REACT_APP_ALLOW_FREE_SUBSCRIPTION || 'false'
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const GITHUB_CLIENT_ID = process.env.REACT_APP_GITHUB_CLIENT_ID || '';


export { API_BASE_URL, WS_BASE, FEATURE_INVITE_TOKEN, ALLOW_FREE_SUBSCRIPTION, GOOGLE_CLIENT_ID, GITHUB_CLIENT_ID };
